<template>
    <div>
      <div class="popup-info popup-icon-info">

          <div class="text">
              <div class="text-size-ml text-bold info-title">Укажите тип публикации</div>

			  <div class="choose-rule-type mt24">
				  <div class="item --rule">
		              <input v-model="value" value="1" type="radio" id="type-rule" name="rule-type">
		              <label for="type-rule" v-if="false">
		              	<div class="name">
		              		Правило
		              	</div>
						<div class="info">
							Регламент, который допускается нарушать только под давлением обстоятельств непреодолимой силы и с обязательным описанием исключения из правил.
						</div>
		              </label>
		          </div>
				  <div class="item --draft mt16">
					 <input v-model="value" value="4" type="radio" id="type-draft" name="rule-type">
					 <label for="type-draft">
						 <div class="name">
 		              		заготовка
 		              	</div>
 						<div class="info">
 							Конспект или мысли, которые желательно не потерять и которые будут полезны другим сотрудникам компании.
 						</div>
					 </label>
				 </div>
			  </div>
          </div>

          <div class="mt32">
              <span class="btn btn--ico" @click="close">
				   <span class="i i-ok7 mr4" ></span>Подтвердить
			   </span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "RuleType",
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.ruleType.name});
            }
        },
		data(){
			return {
				value: false,
			}
		},
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                blockEdit: state => state.rules.blockEdit,
            }),
        }
    }
</script>

<style scoped>

</style>
